/** Client portal login — magic link only */
export const CLIENT_LOGIN_PATH = "/";

/** Staff / admin login — email + password (+ OTP when enabled) */
export const STAFF_LOGIN_PATH = "/admin";

/** Magic-link request: email belongs to a non-client (agent/staff) account */
export const WRONG_PORTAL_STAFF_CODE = "WRONG_PORTAL_STAFF";

export const WRONG_PORTAL_STAFF_MESSAGE =
  "This email is for a travel agent or staff account. Sign in with your password on the agent & staff page.";

/** Magic-link request: unknown, deleted, or inactive client */
export const EMAIL_NOT_RECOGNIZED_CODE = "EMAIL_NOT_RECOGNIZED";

export const EMAIL_NOT_RECOGNIZED_MESSAGE = "This email isn't recognized.";

const EMAIL_QUERY_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isPrefillableLoginEmail(value: string): boolean {
  return EMAIL_QUERY_REGEX.test(value);
}

/** Staff login URL, optionally carrying the email the user already typed. */
export function getStaffLoginPathWithEmail(email?: string): string {
  const trimmed = email?.trim() ?? "";
  if (!trimmed || !isPrefillableLoginEmail(trimmed)) {
    return STAFF_LOGIN_PATH;
  }
  return `${STAFF_LOGIN_PATH}?email=${encodeURIComponent(trimmed)}`;
}

const STAFF_ROUTE_PREFIXES = [
  "/admin",
  "/dashboard",
  "/prospects",
  "/clients",
  "/invoices",
  "/agents",
  "/surveys",
  "/pretrips",
  "/settings",
  "/current-trips",
] as const;

const CLIENT_ROUTE_PREFIXES = ["/my"] as const;

/**
 * Resolve the correct login page for the current route (or an explicit pathname).
 * Client routes → `/`; staff CRM routes → `/admin`.
 */
export function getLoginPathForRoute(pathname?: string): string {
  const path =
    pathname ??
    (typeof window !== "undefined" ? window.location.pathname : CLIENT_LOGIN_PATH);

  if (CLIENT_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix))) {
    return CLIENT_LOGIN_PATH;
  }

  if (STAFF_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix))) {
    return STAFF_LOGIN_PATH;
  }

  return CLIENT_LOGIN_PATH;
}
